export default __webpack_public_path__ + "static/media/AVISOS DE PRIVACIDAD.dec309d0.pdf";